import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CustomRouter } from './components';
import { history } from './utils';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CustomRouter history={history}>
    <App />
  </CustomRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
